<template>
  <div
    class="d-flex justify-content-center flex-column align-items-center py-4 vh-100"
  >
    <div class="initial-loading-screen">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
import accountService from '@/services/accounts'
import { APP_TYPES } from '@/utils/constants'

export default {
  mounted() {
    this.logout()
  },
  methods: {
    clearDataAndRedirect(loginPath) {
      // remove cookies, localStorage data, vue store data
      this.$store.dispatch('unsetAccountId')
      this.$store.dispatch('unsetLocale')

      this.$mpTrack('Logout')
      this.$router.push(loginPath)
    },
    async logout() {
      const app = this.$route.query.app || APP_TYPES.RFP
      const callback = this.$route.query.callback || '/'
      const loginPath = `/login?app=${app}&callback=${callback}`

      try {
        await accountService.deleteToken()
      } catch (e) {
        // do nothing
      } finally {
        this.clearDataAndRedirect(loginPath)
      }
    }
  }
}
</script>
<style>
.initial-loading-screen {
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
}
.initial-loading-screen {
  font-family: sans-serif;
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid #322d59;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #322d59 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
